// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__8oQ6D","label":"Checkbox_label__7Yxbt","checkmark":"Checkbox_checkmark__ZGL+8"};